export const sorts = {
  default: [],
  options: [
    { name: 'Status', key: 'status', options: [{ key: '-status', value: 'Most' }, { key: 'status', value: 'Least' }] },
    { name: 'End date', key: 'date_end', options: [{ key: '-date_end', value: 'Most' }, { key: 'date_end', value: 'Least' }] }
  ]
};
